export default "__VITE_ASSET__BrYg8Qpz__"